import { useGetFeatureFlagsQuery } from "@/app/featureFlagsApi";

/**
 * Hook to access feature flags.
 * Calls the API FeatureFlags endpoint once on first use, then serves
 * from RTK Query cache for all subsequent consumers — no repeated API calls.
 *
 * @returns Object containing individual feature flag states.
 */
export function useFeatureFlags() {
  const { data: flags } = useGetFeatureFlagsQuery();

  return {
    /** Whether the Manage Access feature is enabled */
    isManageAccessEnabled: flags?.ManageAccess ?? false,
    /** Whether the Rename feature is enabled */
    isRenameEnabled: flags?.Rename ?? false,
    /** Whether the Archive feature is enabled */
    isArchiveEnabled: flags?.Archive ?? false,
    /** Whether the Edit workflow feature is enabled */
    isEditEnabled: flags?.Edit ?? false,
  };
}
